import Crud from '../components/CostCenter/Crud'
import Add from '../components/CostCenter/Add'

let routes = {
    path: '/cost-centers',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/cost-centers/add',
            name: 'Novo Centro de Custo',
            component: Add
        },
        {
            path: '/cost-centers/edit/:id?',
            name: 'Editar Centro de Custo',
            component: Add
        },
        {
            path: '/cost-centers',
            name: 'Centros de Custo',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/cost-center.js